export default __webpack_public_path__ + "static/media/barrio_norte.29970b1b.jpg";